(() => {
  const desktop = window.matchMedia('(min-width: 990px)');
  const entries = new Map();
  const initialise = () => {
    document.querySelectorAll('#dinuzo-whisky-storytelling,.dinuzo-whiskey-story,.dinuzo-ball-story,.dinuzo-galaxy-story,.db-story').forEach(story => {
      if (entries.has(story)) return;
      if (!story.querySelector('video,iframe,.dinuzo-global-demo')) {
        const template = document.querySelector('template[data-dinuzo-demo-template]');
        if (template) {
          const demo = template.content.cloneNode(true);
          if (story.firstElementChild) story.firstElementChild.after(demo);
          else story.append(demo);
        }
      }
      const label = document.querySelector('template[data-dinuzo-demo-template]')?.content.querySelector('h2')?.textContent;
      story.querySelectorAll('video').forEach(video => {
        video.controls = true;
        video.playsInline = true;
        if (label) video.setAttribute('aria-label', label);
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          video.autoplay = false;
          video.pause();
        }
      });
      const container = story.closest('.product-information');
      const grid = container?.querySelector('[data-product-grid-content]');
      if (!grid) return;
      const anchor = document.createComment('');
      story.before(anchor);
      const wrapper = document.createElement('div');
      wrapper.className = 'dinuzo-it-story-wide';
      wrapper.hidden = true;
      grid.after(wrapper);
      entries.set(story, { anchor, wrapper });
    });
    document.querySelectorAll('.dinuzo-specs__shell > details:not([data-dinuzo-opened])').forEach(details => {
      details.open = true;
      details.dataset.dinuzoOpened = 'true';
    });
    entries.forEach(({ anchor, wrapper }, story) => {
      if (!anchor.isConnected) { entries.delete(story); wrapper.remove(); return; }
      if (desktop.matches) { wrapper.hidden = false; if (story.parentElement !== wrapper) wrapper.append(story); }
      else { anchor.after(story); wrapper.hidden = true; }
    });
  };
  desktop.addEventListener('change', initialise);
  document.addEventListener('shopify:section:load', initialise);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
})();

